import { Map } from 'immutable'
import { AsyncState, loadingAsyncState, mk_pair, Pair } from 'widgets-for-react'
import { ImageSize, Url } from '../../cms/blocks/types.gen'
import { Block } from '../types_and_parser/standard_blocks.gen'
import { PairAsyncImage } from '../../cms/state/types.gen'
import { ExtraImages } from '../../public_site/utils/extra_images.mod'
import { isCustomBlock } from '../../public_site/blocks/custom_blocks/types.mod'
import { WordPress } from '../wordpress_api'
import { CustomBlock } from '../types_and_parser/custom_blocks.mod'

export function loadMedia(image: number): AsyncState<Map<ImageSize<ExtraImages>, Url>> {
  return loadingAsyncState<Map<ImageSize<ExtraImages>, Url>>(_ => {
    return WordPress.media<WordPress.MediaResponse>()
      .findById(image)
      .then(response => {
        const sizes = response.data.media_details.sizes
        let value = Map<ImageSize<ExtraImages>, Url>().set('full', sizes.full.source_url)

        if (sizes.thumbnail) value = value.set('thumbnail', sizes.thumbnail.source_url)
        if (sizes.medium) value = value.set('medium', sizes.medium.source_url)
        if (sizes.medium_large) value = value.set('medium_large', sizes.medium_large.source_url)
        if (sizes.large) value = value.set('large', sizes.large.source_url)
        if (sizes.media) value = value.set('media', sizes.media.source_url)
        if (sizes.teaser) value = value.set('teaser', sizes.teaser.source_url)
        if (sizes.grid) value = value.set('grid', sizes.grid.source_url)
        if (sizes.quote) value = value.set('quote', sizes.quote.source_url)
        if (sizes.attention) value = value.set('attention', sizes.attention.source_url)
        if (sizes.stack) value = value.set('stack', sizes.stack.source_url)
        if (sizes.stack) value = value.set('carousel', sizes.stack.source_url)
        if (sizes.stack) value = value.set('highlightFirst', sizes.stack.source_url)
        if (sizes.stack) value = value.set('highlightSecond', sizes.stack.source_url)
        if (sizes.stack) value = value.set('highlightThird', sizes.stack.source_url)

        return { status: 200, value, kind: 'result' as 'result' }
      })
      .catch(error => {
        console.error(error)
        return { status: 400, kind: 'failed' as 'failed' }
      })
  })
}

export const WordPressBlockImagesLoader = (
  block: Block | CustomBlock,
  get_images_from_custom_block?: (b: CustomBlock) => Array<PairAsyncImage<ExtraImages>>
): Array<Pair<number, AsyncState<Map<ImageSize<ExtraImages>, Url>>>> => {
  switch (block.kind) {
    // case 'featured_content':
    //   return block.image ? [mk_pair(block.image, loadMedia(block.image))] : []
    // case "grid_blocks_image":
    //   return block.field_grid_blocks.map(b =>
    //     mk_pair(b.field_image.field_media_image.image.id, loadMedia(b.field_image.field_media_image.image) as AsyncState<Map<ImageSize<ExtraImages>, Url>>)
    //   ).toArray()
    // case 'media':
    //   return [
    //     // mk_pair(block. field_media.bundle === "image" ? block.field_media.field_media_image.image.id : null, loadMedia(block.field_media.bundle === "image" ? block.field_media.field_media_image.image : null) as AsyncState<Map<ImageSize<ExtraImages>, Url>>)
    //     mk_pair(block.image, loadMedia(block.image))
    //   ]
    // case 'quote':
    //   return block.image ? [mk_pair(block.image, loadMedia(block.image))] : []
    default:
      if (get_images_from_custom_block && isCustomBlock(block)) {
        return get_images_from_custom_block(block)
      }
      return []
  }
}
